import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'

export const DeactivationPopup = ({ isOpen, onClose, onConfirm }) => (
  <SimplePopup
    isDestructive
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title={I18n.t('publisher.organization_settings.user_provisioning.groups.deactivation_popup.title')}
    confirmLabel={I18n.t('publisher.organization_settings.user_provisioning.groups.deactivation_popup.confirm')}
    cancelLabel={I18n.t('publisher.organization_settings.user_provisioning.groups.deactivation_popup.cancel')}
  >
    {I18n.t('publisher.organization_settings.user_provisioning.groups.deactivation_popup.body')}
  </SimplePopup>
)
